// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type StartExportEmployeesMutationVariables = Types.Exact<{
  format: Types.EmployeeExportFormat;
  timezoneOffset: Types.Scalars['Long']['input'];
  filter: Types.InputMaybe<Types.ListEmployeesFilterInput>;
  employeeIds: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  sort: Types.InputMaybe<Types.ListEmployeesSortInput>;
}>;

export type StartExportEmployeesMutation = { __typename?: 'Mutation' } & {
  startExportEmployees: { __typename?: 'EmployeeExportHistory' } & Pick<Types.EmployeeExportHistory, 'id' | 'status'>;
};

export type StartExportExternalAccountListMutationVariables = Types.Exact<{
  filter: Types.ListExternalAccountsFilterInput;
}>;

export type StartExportExternalAccountListMutation = { __typename?: 'Mutation' } & {
  startExportExternalAccountList: { __typename?: 'ExternalAccountExportHistory' } & Pick<
    Types.ExternalAccountExportHistory,
    'id' | 'status'
  >;
};

export type StartExportReportNumberOfEmployeeMutationVariables = Types.Exact<{
  startYearMonth: Types.Scalars['YearMonth']['input'];
  endYearMonth: Types.Scalars['YearMonth']['input'];
  contractTypes: Types.InputMaybe<Array<Types.ContractType> | Types.ContractType>;
  exportTypes: Array<Types.NumberOfEmployeeExportType> | Types.NumberOfEmployeeExportType;
}>;

export type StartExportReportNumberOfEmployeeMutation = { __typename?: 'Mutation' } & {
  startExportReportNumberOfEmployee: { __typename?: 'NumberOfEmployeeExportHistory' } & Pick<
    Types.NumberOfEmployeeExportHistory,
    'id' | 'status'
  >;
};

export type StartExportPerformanceReviewDetailsMutationVariables = Types.Exact<{
  period: Types.PerformanceReviewPeriodInput;
  filter: Types.InputMaybe<Types.ListPerformanceReviewFilterInput>;
  employeeIds: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;

export type StartExportPerformanceReviewDetailsMutation = { __typename?: 'Mutation' } & {
  startExportPerformanceReviewDetails: { __typename?: 'PerformanceReviewExportHistory' } & Pick<
    Types.PerformanceReviewExportHistory,
    'id' | 'status'
  >;
};

export type StartExportPerformanceReviewListMutationVariables = Types.Exact<{
  period: Types.PerformanceReviewPeriodInput;
  filter: Types.InputMaybe<Types.ListPerformanceReviewFilterInput>;
  employeeIds: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;

export type StartExportPerformanceReviewListMutation = { __typename?: 'Mutation' } & {
  startExportPerformanceReviewList: { __typename?: 'PerformanceReviewExportHistory' } & Pick<
    Types.PerformanceReviewExportHistory,
    'id' | 'status'
  >;
};

export type StartExportPerformanceReviewResultsMutationVariables = Types.Exact<{
  period: Types.PerformanceReviewPeriodInput;
  filter: Types.InputMaybe<Types.PerformanceReviewResultFilterInput>;
  employeeIds: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;

export type StartExportPerformanceReviewResultsMutation = { __typename?: 'Mutation' } & {
  startExportPerformanceReviewResults: { __typename?: 'PerformanceReviewExportHistory' } & Pick<
    Types.PerformanceReviewExportHistory,
    'id' | 'status'
  >;
};

export const StartExportEmployeesDocument = /*#__PURE__*/ gql`
    mutation startExportEmployees($format: EmployeeExportFormat!, $timezoneOffset: Long!, $filter: ListEmployeesFilterInput, $employeeIds: [ID!], $sort: ListEmployeesSortInput) {
  startExportEmployees(
    format: $format
    timezoneOffset: $timezoneOffset
    filter: $filter
    employeeIds: $employeeIds
    sort: $sort
  ) {
    id
    status
  }
}
    `;
export type StartExportEmployeesMutationFn = Apollo.MutationFunction<
  StartExportEmployeesMutation,
  StartExportEmployeesMutationVariables
>;

/**
 * __useStartExportEmployeesMutation__
 *
 * To run a mutation, you first call `useStartExportEmployeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartExportEmployeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startExportEmployeesMutation, { data, loading, error }] = useStartExportEmployeesMutation({
 *   variables: {
 *      format: // value for 'format'
 *      timezoneOffset: // value for 'timezoneOffset'
 *      filter: // value for 'filter'
 *      employeeIds: // value for 'employeeIds'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useStartExportEmployeesMutation(
  baseOptions?: Apollo.MutationHookOptions<StartExportEmployeesMutation, StartExportEmployeesMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartExportEmployeesMutation, StartExportEmployeesMutationVariables>(
    StartExportEmployeesDocument,
    options,
  );
}
export type StartExportEmployeesMutationHookResult = ReturnType<typeof useStartExportEmployeesMutation>;
export type StartExportEmployeesMutationOptions = Apollo.BaseMutationOptions<
  StartExportEmployeesMutation,
  StartExportEmployeesMutationVariables
>;
export const StartExportExternalAccountListDocument = /*#__PURE__*/ gql`
    mutation startExportExternalAccountList($filter: ListExternalAccountsFilterInput!) {
  startExportExternalAccountList(filter: $filter) {
    id
    status
  }
}
    `;
export type StartExportExternalAccountListMutationFn = Apollo.MutationFunction<
  StartExportExternalAccountListMutation,
  StartExportExternalAccountListMutationVariables
>;

/**
 * __useStartExportExternalAccountListMutation__
 *
 * To run a mutation, you first call `useStartExportExternalAccountListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartExportExternalAccountListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startExportExternalAccountListMutation, { data, loading, error }] = useStartExportExternalAccountListMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useStartExportExternalAccountListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartExportExternalAccountListMutation,
    StartExportExternalAccountListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartExportExternalAccountListMutation, StartExportExternalAccountListMutationVariables>(
    StartExportExternalAccountListDocument,
    options,
  );
}
export type StartExportExternalAccountListMutationHookResult = ReturnType<
  typeof useStartExportExternalAccountListMutation
>;
export type StartExportExternalAccountListMutationOptions = Apollo.BaseMutationOptions<
  StartExportExternalAccountListMutation,
  StartExportExternalAccountListMutationVariables
>;
export const StartExportReportNumberOfEmployeeDocument = /*#__PURE__*/ gql`
    mutation startExportReportNumberOfEmployee($startYearMonth: YearMonth!, $endYearMonth: YearMonth!, $contractTypes: [ContractType!], $exportTypes: [NumberOfEmployeeExportType!]!) {
  startExportReportNumberOfEmployee(
    filter: {startYearMonth: $startYearMonth, endYearMonth: $endYearMonth, contractTypes: $contractTypes, addSubtotal: false, exportTypes: $exportTypes}
  ) {
    id
    status
  }
}
    `;
export type StartExportReportNumberOfEmployeeMutationFn = Apollo.MutationFunction<
  StartExportReportNumberOfEmployeeMutation,
  StartExportReportNumberOfEmployeeMutationVariables
>;

/**
 * __useStartExportReportNumberOfEmployeeMutation__
 *
 * To run a mutation, you first call `useStartExportReportNumberOfEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartExportReportNumberOfEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startExportReportNumberOfEmployeeMutation, { data, loading, error }] = useStartExportReportNumberOfEmployeeMutation({
 *   variables: {
 *      startYearMonth: // value for 'startYearMonth'
 *      endYearMonth: // value for 'endYearMonth'
 *      contractTypes: // value for 'contractTypes'
 *      exportTypes: // value for 'exportTypes'
 *   },
 * });
 */
export function useStartExportReportNumberOfEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartExportReportNumberOfEmployeeMutation,
    StartExportReportNumberOfEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartExportReportNumberOfEmployeeMutation,
    StartExportReportNumberOfEmployeeMutationVariables
  >(StartExportReportNumberOfEmployeeDocument, options);
}
export type StartExportReportNumberOfEmployeeMutationHookResult = ReturnType<
  typeof useStartExportReportNumberOfEmployeeMutation
>;
export type StartExportReportNumberOfEmployeeMutationOptions = Apollo.BaseMutationOptions<
  StartExportReportNumberOfEmployeeMutation,
  StartExportReportNumberOfEmployeeMutationVariables
>;
export const StartExportPerformanceReviewDetailsDocument = /*#__PURE__*/ gql`
    mutation startExportPerformanceReviewDetails($period: PerformanceReviewPeriodInput!, $filter: ListPerformanceReviewFilterInput, $employeeIds: [ID!]) {
  startExportPerformanceReviewDetails(
    period: $period
    filter: $filter
    employeeIds: $employeeIds
  ) {
    id
    status
  }
}
    `;
export type StartExportPerformanceReviewDetailsMutationFn = Apollo.MutationFunction<
  StartExportPerformanceReviewDetailsMutation,
  StartExportPerformanceReviewDetailsMutationVariables
>;

/**
 * __useStartExportPerformanceReviewDetailsMutation__
 *
 * To run a mutation, you first call `useStartExportPerformanceReviewDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartExportPerformanceReviewDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startExportPerformanceReviewDetailsMutation, { data, loading, error }] = useStartExportPerformanceReviewDetailsMutation({
 *   variables: {
 *      period: // value for 'period'
 *      filter: // value for 'filter'
 *      employeeIds: // value for 'employeeIds'
 *   },
 * });
 */
export function useStartExportPerformanceReviewDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartExportPerformanceReviewDetailsMutation,
    StartExportPerformanceReviewDetailsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartExportPerformanceReviewDetailsMutation,
    StartExportPerformanceReviewDetailsMutationVariables
  >(StartExportPerformanceReviewDetailsDocument, options);
}
export type StartExportPerformanceReviewDetailsMutationHookResult = ReturnType<
  typeof useStartExportPerformanceReviewDetailsMutation
>;
export type StartExportPerformanceReviewDetailsMutationOptions = Apollo.BaseMutationOptions<
  StartExportPerformanceReviewDetailsMutation,
  StartExportPerformanceReviewDetailsMutationVariables
>;
export const StartExportPerformanceReviewListDocument = /*#__PURE__*/ gql`
    mutation startExportPerformanceReviewList($period: PerformanceReviewPeriodInput!, $filter: ListPerformanceReviewFilterInput, $employeeIds: [ID!]) {
  startExportPerformanceReviewList(
    period: $period
    filter: $filter
    employeeIds: $employeeIds
  ) {
    id
    status
  }
}
    `;
export type StartExportPerformanceReviewListMutationFn = Apollo.MutationFunction<
  StartExportPerformanceReviewListMutation,
  StartExportPerformanceReviewListMutationVariables
>;

/**
 * __useStartExportPerformanceReviewListMutation__
 *
 * To run a mutation, you first call `useStartExportPerformanceReviewListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartExportPerformanceReviewListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startExportPerformanceReviewListMutation, { data, loading, error }] = useStartExportPerformanceReviewListMutation({
 *   variables: {
 *      period: // value for 'period'
 *      filter: // value for 'filter'
 *      employeeIds: // value for 'employeeIds'
 *   },
 * });
 */
export function useStartExportPerformanceReviewListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartExportPerformanceReviewListMutation,
    StartExportPerformanceReviewListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartExportPerformanceReviewListMutation,
    StartExportPerformanceReviewListMutationVariables
  >(StartExportPerformanceReviewListDocument, options);
}
export type StartExportPerformanceReviewListMutationHookResult = ReturnType<
  typeof useStartExportPerformanceReviewListMutation
>;
export type StartExportPerformanceReviewListMutationOptions = Apollo.BaseMutationOptions<
  StartExportPerformanceReviewListMutation,
  StartExportPerformanceReviewListMutationVariables
>;
export const StartExportPerformanceReviewResultsDocument = /*#__PURE__*/ gql`
    mutation startExportPerformanceReviewResults($period: PerformanceReviewPeriodInput!, $filter: PerformanceReviewResultFilterInput, $employeeIds: [ID!]) {
  startExportPerformanceReviewResults(
    period: $period
    filter: $filter
    employeeIds: $employeeIds
  ) {
    id
    status
  }
}
    `;
export type StartExportPerformanceReviewResultsMutationFn = Apollo.MutationFunction<
  StartExportPerformanceReviewResultsMutation,
  StartExportPerformanceReviewResultsMutationVariables
>;

/**
 * __useStartExportPerformanceReviewResultsMutation__
 *
 * To run a mutation, you first call `useStartExportPerformanceReviewResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartExportPerformanceReviewResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startExportPerformanceReviewResultsMutation, { data, loading, error }] = useStartExportPerformanceReviewResultsMutation({
 *   variables: {
 *      period: // value for 'period'
 *      filter: // value for 'filter'
 *      employeeIds: // value for 'employeeIds'
 *   },
 * });
 */
export function useStartExportPerformanceReviewResultsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartExportPerformanceReviewResultsMutation,
    StartExportPerformanceReviewResultsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartExportPerformanceReviewResultsMutation,
    StartExportPerformanceReviewResultsMutationVariables
  >(StartExportPerformanceReviewResultsDocument, options);
}
export type StartExportPerformanceReviewResultsMutationHookResult = ReturnType<
  typeof useStartExportPerformanceReviewResultsMutation
>;
export type StartExportPerformanceReviewResultsMutationOptions = Apollo.BaseMutationOptions<
  StartExportPerformanceReviewResultsMutation,
  StartExportPerformanceReviewResultsMutationVariables
>;
